<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row>
        <v-flex>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="primary"
            grow
          >
            <v-tab
              v-for="item in items"
              :key="item"
              @click="changeTab(item)"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="item in items"
              :key="item"
            >
              <v-flex v-if="item === assist.dataType.NotificationTab.WA_NEED_TO_SEND || item === assist.dataType.NotificationTab.WAI_NEED_TO_SEND">
                <v-btn
                  dark
                  small
                  tile
                  color="#5BCDF2"
                  class="btn-send-disabled"
                  @click="sendEmailHandler"
                  ref="sendBtn"
                  id="sendBtn"
                >Send Email</v-btn>
                <v-btn
                  dark
                  small
                  tile
                  color="#5c82e3"
                  class="btn-all-disabled"
                  @click="sendAllEmailHandler"
                  ref="sendAllBtn"
                  id="sendAllBtn"
                >Send All</v-btn>
                <div>
                  <span class="loansNumber">{{ selected.length }}</span>
                  <span class="loansTips">Loans have been selected</span>
                </div>
                <div>
                  <span class="allTips">Loans Need To Be Send</span>
                  <span class="allNumber">{{ options.pageCount }}</span>
                </div>
              </v-flex>
              <v-data-table
                v-model="selected"
                :headers="complex.headers"
                :items="complex.items"
                item-key="id"
                :loading="loading"
                :footer-props="footerProps"
                :options.sync="options"
                :server-items-length="options.pageCount"
                :show-select="item === assist.dataType.NotificationTab.WA_NEED_TO_SEND || item === assist.dataType.NotificationTab.WAI_NEED_TO_SEND"
                class="p-t-5"
              >
                <template v-slot:item.fullName="{ item }">
                  <td>{{ assist.tool.getFullName(item) }}</td>
                </template>
                <template v-slot:item.payrollFrequency="{ item }">
                  <td>{{ assist.tool.getEnumTextByValue(assist.dataType.PayrollFrequencyEnum, item.payrollFrequency) }}</td>
                </template>
                <template v-slot:item.principal="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.principal) }}</td>
                </template>
                <template v-slot:item.interest="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.interest) }}</td>
                </template>
                <template v-slot:item.lateFee="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.lateFee) }}</td>
                </template>
                <template v-slot:item.nsfFee="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.nsfFee) }}</td>
                </template>
                <template v-slot:item.amount="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.amount) }}</td>
                </template>
                <template v-slot:item.unpaidFee="{ item }">
                  <td>{{ assist.tool.formatCurrency(item.unpaidFee) }}</td>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { Tool, DataType, Popup } from '@/util/index'
import { CollectionApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  data () {
    return {
      assist: {
        tool: tool,
        dataType: DataType
      },
      tab: null,
      items: [
        DataType.NotificationTab.WA_NEED_TO_SEND, DataType.NotificationTab.WA_SENDING, DataType.NotificationTab.WA_SUCCESSFULLY,
        DataType.NotificationTab.WAI_NEED_TO_SEND, DataType.NotificationTab.WAI_SENDING, DataType.NotificationTab.WAI_SUCCESSFULLY
      ],
      emailType: DataType.EmailTypeEnum.WA_EMAIL_TYPE.value,
      selected: [],
      tabName: '',
      loading: false,
      footerProps: {
        'items-per-page-options': [10, 20, 50]
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      complex: {
        headers: LIST_TABLE_HEADER.ThirdPartySendEmailHeader,
        items: []
      }
    }
  },
  computed: {
  },
  watch: {
    'options.page': {
      handler () {
        this.searchData()
      }
    },
    'options.itemsPerPage': {
      handler () {
        this.searchData()
      }
    },
    '$store.getters.getRuntimePortfolio': {
      handler (newVal, oldVal) {
        if (tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.searchData()
        }
      }
    },
    selected () {
      const sendBtnRef = this.$refs.sendBtn
      if (sendBtnRef !== undefined) {
        if (this.selected.length === 0) {
          for (const item of sendBtnRef) {
            item.$el.disabled = true
            item.$el.className = 'btn-send-disabled v-btn v-btn--is-elevated v-btn--has-bg v-btn--tile theme--dark v-size--small'
          }
        } else if (this.selected.length > 0) {
          for (const item of sendBtnRef) {
            item.$el.disabled = false
            item.$el.className = 'btn-send v-btn v-btn--is-elevated v-btn--has-bg v-btn--tile theme--dark v-size--small'
          }
        }
      }
    }
  },
  mounted () {
    this.tabName = DataType.NotificationTab.WA_NEED_TO_SEND
    this.searchData()
  },
  created () {
    this.changeTab()
  },
  methods: {
    changeTab (tab) {
      switch (tab) {
        case DataType.NotificationTab.WA_NEED_TO_SEND:
        case DataType.NotificationTab.WA_SENDING:
        case DataType.NotificationTab.WA_SUCCESSFULLY:
        case DataType.NotificationTab.WAI_NEED_TO_SEND:
        case DataType.NotificationTab.WAI_SENDING:
        case DataType.NotificationTab.WAI_SUCCESSFULLY:
          this.tabName = tab
          break
        default:
          break
      }
      this.queryEmail()
    },
    searchData () {
      this.queryEmail()
    },
    sendAllEmailHandler () {
      const $this = this
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        popup.popupForWarning('Please select portfolio')
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }
      popup.popupForInfo('Are you sure to send an email to ALL of loan?', { showCancelButton: true }, function () {
        $this.sendAllEmail()
      })
    },
    sendEmailHandler () {
      const $this = this
      const selected = $this.selected
      if (selected.length <= 0) {
        popup.popupForError('Not select any loan !')
        return
      }
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        popup.popupForWarning('Please select portfolio')
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }
      popup.popupForInfo(`Are you sure to send an email to the ${selected.length} selected pieces of loan?`, { showCancelButton: true }, function () {
        const loanIdList = []
        for (const item of selected) {
          loanIdList.push(item.id)
        }
        $this.sendEmail(loanIdList)
      })
    },
    queryEmail () {
      this.selected = []
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }
      if (tool.isEmpty(tool.getQueryType(this.tabName))) {
        return
      }
      this.loading = true
      const input = {
        queryType: tool.getQueryType(this.tabName),
        portfolioId: this.$store.getters.getRuntimePortfolio[0],
        pageNum: this.options.page,
        pageSize: this.options.itemsPerPage,
        emailType: this.emailType,
        collectionProvider: tool.getCollectionProvider(this.tabName)
      }
      CollectionApi.queryEmail(input, this.queryEmailCallBack)
    },
    queryEmailCallBack (res) {
      this.loading = false
      if (tool.isNotEmpty(res)) {
        this.options.page = res.page
        this.options.itemsPerPage = res.size
        this.options.pageCount = res.total
        this.complex.items = res.data
      }
      const sendAllBtnRef = this.$refs.sendAllBtn
      if (sendAllBtnRef !== undefined) {
        if (this.options.pageCount === 0) {
          for (const item of sendAllBtnRef) {
            item.$el.disabled = true
            item.$el.className = 'btn-all-disabled v-btn v-btn--is-elevated v-btn--has-bg v-btn--tile theme--dark v-size--small'
          }
        } else if (this.options.pageCount > 0) {
          for (const item of sendAllBtnRef) {
            item.$el.disabled = false
            item.$el.className = 'btn-all v-btn v-btn--is-elevated v-btn--has-bg v-btn--tile theme--dark v-size--small'
          }
        }
      }
    },
    sendEmail (loanIdList) {
      const $this = this
      const input = {
        portfolioId: this.$store.getters.getRuntimePortfolio[0],
        loanIdList: loanIdList,
        emailType: this.emailType,
        collectionProvider: tool.getCollectionProvider(this.tabName)
      }
      CollectionApi.sendEmail(input, function () {
        $this.selected = []
        $this.queryEmail()
      })
    },
    sendAllEmail () {
      const $this = this
      const input = {
        portfolioId: this.$store.getters.getRuntimePortfolio[0],
        emailType: this.emailType,
        collectionProvider: tool.getCollectionProvider(this.tabName)
      }
      CollectionApi.sendAllEmail(input, function () {
        $this.selected = []
        $this.queryEmail()
      })
    }
  }
}
</script>
<style scoped>
.btn-all {
  position: absolute;
  float: right;
  right: 30px;
  width: 92px;
  height: 34px;
  border-radius: 2px;
  box-shadow: 0 4px 8px 0 rgba(101,133,216,0.22);
  text-transform: none;
}
.btn-all-disabled {
  position: absolute;
  float: right;
  right: 30px;
  width: 92px;
  height: 34px;
  border-radius: 2px;
  box-shadow: 0 8px 16px 0 rgba(191,206,222,0.25);
  text-transform: none;
  background: #E8EBF5 !important;
  color: #fff;
  cursor: auto;
}
.btn-send {
  position: absolute;
  float: right;
  right: 146px;
  width: 114px;
  height: 34px;
  border-radius: 2px;
  box-shadow: 0 4px 8px 0 rgba(101,133,216,0.22);
  text-transform: none;
}
.btn-send-disabled {
  position: absolute;
  float: right;
  right: 146px;
  width: 114px;
  height: 34px;
  border-radius: 2px;
  box-shadow: 0 8px 16px 0 rgba(191,206,222,0.25);
  text-transform: none;
  background: #E8EBF5 !important;
  color: #fff;
  cursor: auto;
}
.loansTips {
  position: absolute;
  float: right;
  right: 276px;
  width: 185px;
  height: 18px;
  line-height: 18px;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  color: #c4c7d8;
  margin-top: 6px;
}
.loansNumber {
  position: absolute;
  float: right;
  right: 469px;
  height: 18px;
  line-height: 18px;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  color: #3F4360;
  margin-top: 6px;
}
.allTips {
  width: 218px;
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  color: #3F4360;
}
.allNumber {
  margin-left: 8px;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #5C82E3;
}
.v-tab {
  text-transform: capitalize;
}
</style>
